module.exports = __webpack_public_path__ + "media/custom/images/pocstock-signup-business-f23bd03d0e40ccd24a50e98d048b559e.png";